{
  "en": {
    "answers": [
      {
        "id": 1328685,
        "text": "1 – Fully applies",
        "is_right": true
      },
      {
        "id": 1328686,
        "text": "2",
        "is_right": false
      },
      {
        "id": 1328687,
        "text": "3",
        "is_right": false
      },
      {
        "id": 1328688,
        "text": "4",
        "is_right": false
      },
      {
        "id": 1328689,
        "text": "5 – Does not apply at all",
        "is_right": false
      }
    ],
    "tags": [
      {
        "id": 22080,
        "name": "Evaluation"
      },
      {
        "id": 144338,
        "name": "Rating"
      },
      {
        "id": 156068,
        "name": "Sample Question"
      },
      {
        "id": 156083,
        "name": "Survey Question"
      }
    ],
    "text": "The course content was helpful.",
    "display_in_order": true,
    "is_poll_question": true,
    "type": 2,
    "created_at": "2025-09-02T16:24:50.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:55:58.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "explanation": "### Please select a value on the scale from **1 for the highest agreement** to **5 for the lowest agreement**:\n\n* **1** = highest agreement (“Fully applies”)\n* **5** = lowest agreement (“Does not apply at all”)\n\n### This type of scale is particularly useful for capturing **attitudes, opinions, or subjective perceptions** in a more differentiated way.",
    "has_explanation": true,
    "num_answers": 5
  },
  "de": {
    "answers": [
      {
        "id": 1329043,
        "text": "1 Trifft völlig zu",
        "is_right": true
      },
      {
        "id": 1329044,
        "text": "2",
        "is_right": false
      },
      {
        "id": 1329045,
        "text": "3",
        "is_right": false
      },
      {
        "id": 1329046,
        "text": "4",
        "is_right": false
      },
      {
        "id": 1329047,
        "text": "5 Trifft gar nicht zu",
        "is_right": false
      }
    ],
    "tags": [
      {
        "id": 9427,
        "name": "Musterfrage"
      },
      {
        "id": 14279,
        "name": "Umfragen/Evaluationen"
      }
    ],
    "text": "Die Lerninhalte des Kurses waren hilfreich.",
    "display_in_order": true,
    "is_poll_question": true,
    "type": 2,
    "created_at": "2025-09-03T08:00:33.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:28:11.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "explanation": "### Bitte wähle einen Wert auf der Skala von 1 für den höchsten Wert bis 5 für den niedrigsten Wert:\n\n* **1** = höchste Zustimmung („Trifft völlig zu“)\n* **5** = geringste Zustimmung („Trifft gar nicht zu“)\n\n### Diese Art von Skala eignet sich besonders, um Einstellungen, Meinungen oder subjektive Wahrnehmungen differenziert zu erfassen.",
    "has_explanation": true,
    "num_answers": 5
  }
}
